import { Stack } from '@mui/material'
import apiManagerUser from 'api/manager-users'
import { DEFAULT_ERROR } from 'constants/common'
import { useLogin } from 'hooks'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { toastError } from 'utils/helpers'
import { setLoginStep } from '../loginSlice'
import { LOGIN_STEP } from '../constant'
import FormLoginWith2FA from './FormLoginWith2FA'
import { endSession as logout } from 'store/sessionSlice'
import { useAuthFlow } from '../../AuthFlowContext'

const LoginWith2FA = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { handleLoginSuccess } = useLogin()
    const { sso, clearSSOFlow } = useAuthFlow()
    const { tempToken } = sso

    const [isLoading, setIsLoading] = useState(false)
    const [waitTime, setWaitTime] = useState(0)
    const loadingTimerRef = useRef()

    const handleConfirmCode = async (data) => {
        setIsLoading(true)
        try {
            const errorTitle = data.backup ? 'toast.error.title.code2faBackupError' : 'toast.error.title.code2faError'
            const res = await apiManagerUser.verifyLogin2FA({
                otp: data.code,
                is_backup_code: data.backup ? 1 : 0
            }, tempToken)

            if (res?.data.code === 0) {
                handleLoginSuccess(res.data.data)
                clearSSOFlow()
            } else if (res.data.code === 5) {   // invalid
                toastError(t(errorTitle))
            } else if (res.data.code === 2) {
                toastError(t('toast.error.title.expiredCode'))
                clearSSOFlow()
                dispatch(logout())
            }
            else if (res.data.code === 3) {   // max try
                setWaitTime(res.data.wait_time ?? 0)
            } else {
                toastError(t(errorTitle))
            }
        } catch (error) {
            toastError(t(DEFAULT_ERROR))
        } finally {
            window.clearTimeout(loadingTimerRef.current)
            loadingTimerRef.current = window.setTimeout(() => setIsLoading(false), 1000)
        }
    }

    useEffect(() => () => window.clearTimeout(loadingTimerRef.current), [])

    useEffect(() => {
        if (!tempToken) {
            dispatch(setLoginStep(LOGIN_STEP.SYSTEM))
            return undefined
        }

        const handleBack = (event) => {
            clearSSOFlow()
            dispatch(setLoginStep(LOGIN_STEP.SYSTEM))
        };

        window.addEventListener('popstate', handleBack);

        return () => {
            window.removeEventListener('popstate', handleBack);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearSSOFlow, dispatch, tempToken]);

    return (
        <Stack>
            <FormLoginWith2FA handleConfirmCode={handleConfirmCode} isLoading={isLoading} waitTime={waitTime} setWaitTime={setWaitTime} />
        </Stack>
    )
}

export default LoginWith2FA
